module.exports = __webpack_public_path__ + "static/media/return-to-fertility-silhouette@1x.742d0290.png";